/**
 * ヘッダー用ロゴ。zenk.co.jp のロゴ SVG(zenk-logo.svg)からマーク(赤のグラデーション)と
 * ZENK の文字パスを取り出したもの。画像ではなく SVG なので背景は透過し、文字色は currentColor。
 * ファビコンは共有 Drive「ロゴ」の logo_mark(180×180).png(apps/web/public/favicon.png)。
 */
export function ZenkLogo({
  className = "",
  subtitle,
}: {
  className?: string;
  /** ZENK の下に小さく添える語(例: 社内ポータル)。ロゴの一部として見せる */
  subtitle?: string;
}) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      {/* viewBox はマークの実際の描画範囲(x: 0〜157.88, y: 0〜93.105)に合わせる。150 幅では右端が見切れる */}
      <svg viewBox="0 0 157.88 93.105" className="h-7 w-auto" role="img" aria-label="ZENK">
        <defs>
          <linearGradient
            id="zenk-logo-gr1"
            x1="94.983"
            x2="190.45"
            y1="199.02"
            y2="329.37"
            gradientTransform="translate(-86.957 -193.92)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#DE2A1C" offset="0.0056" />
            <stop stopColor="#A12B1D" offset="1" />
          </linearGradient>
          <linearGradient
            id="zenk-logo-gr2"
            x1="165.05"
            x2="260.95"
            y1="147.09"
            y2="278.03"
            gradientTransform="translate(-86.957 -193.92)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#DE2A1C" offset="0.0056" />
            <stop stopColor="#A12B1D" offset="1" />
          </linearGradient>
          <linearGradient
            id="zenk-logo-gr3"
            x1="132.37"
            x2="227.87"
            y1="171.62"
            y2="302.02"
            gradientTransform="translate(-86.957 -193.92)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#DE2A1C" offset="0.0056" />
            <stop stopColor="#A12B1D" offset="1" />
          </linearGradient>
          <linearGradient
            id="zenk-logo-gr4"
            x1="141.02"
            x2="236.8"
            y1="164.78"
            y2="295.56"
            gradientTransform="translate(-86.957 -193.92)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#DE2A1C" offset="0.0056" />
            <stop stopColor="#A12B1D" offset="1" />
          </linearGradient>
        </defs>
        <path
          fill="url(#zenk-logo-gr1)"
          d="m46.418 20.771c-1.433-1.312-3.964-1.563-5.627-0.556l-39.401 23.914c-1.662 1.016-1.862 2.924-0.447 4.262l46.471 43.765c1.415 1.337 3.643 1.25 4.944-0.191l30.193-33.379c1.307-1.441 1.198-3.69-0.234-5.002z"
        />
        <path
          fill="url(#zenk-logo-gr2)"
          d="m132.36 14.736c-1.455-1.285-3.69-1.138-4.959 0.339l-9.868 11.436c-1.272 1.477-1.125 3.734 0.325 5.028l28.942 25.892c1.45 1.303 3.278 0.903 4.063-0.877l6.66-15.09c0.782-1.78 0.235-4.289-1.224-5.574z"
        />
        <path
          fill="url(#zenk-logo-gr3)"
          d="m106.77 26.624-28.443-25.469c-1.445-1.303-3.994-1.537-5.652-0.53l-22.49 13.651c-1.668 1.007-1.85 2.908-0.408 4.22l35.246 32.17c1.438 1.303 3.678 1.199 4.984-0.243l17.02-18.814c1.306-1.442 1.188-3.682-0.257-4.985z"
        />
        <path
          fill="url(#zenk-logo-gr4)"
          d="m114.68 33.719c-1.445-1.294-3.673-1.155-4.94 0.313l-16.607 19.24c-1.272 1.477-1.138 3.751 0.295 5.063l36.662 33.449c1.433 1.311 3.248 0.929 4.038-0.843l11.162-25.295c0.786-1.78 0.243-4.298-1.207-5.592z"
        />
      </svg>
      <span className="flex flex-col items-start gap-1">
        <svg viewBox="208 34 262 34" className="h-3.5 w-auto fill-current" aria-hidden="true">
          <path d="m210.06 41.056v-4.871h29.21v4.871l-21.887 19.423h21.887v4.871h-29.21v-4.906l21.861-19.388z" />
          <path d="m286.13 65.349v-29.165h29.211v4.871h-24.332v7.216h19.469v4.887h-19.469v7.32h24.332v4.871z" />
          <path d="m362.19 65.349v-29.165h4.879l19.418 21.862v-21.862h4.879v29.165h-4.924l-19.381-21.828 8e-3 21.828z" />
          <path d="m438.21 65.349v-29.165h4.877v12.147l19.473-12.147h4.867l-0.01 2.37-19.555 12.2 19.582 12.129-0.018 2.466h-4.871l-19.469-12.165v12.165z" />
        </svg>
        {subtitle && (
          <span className="text-[10px] leading-none font-medium tracking-[0.3em] text-muted-foreground">
            {subtitle}
          </span>
        )}
      </span>
    </span>
  );
}
